import classNames from "classnames";
import ImageCell from "./ImageCell";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";
import { ProductCategory } from "../../types/ProductCategory";
import GridCell, { GridCellCommonProps } from "./GridCell";
import { useProductTranslations } from "../../hooks/TranslationHooks";
import { shopUrl } from "../../config/urls";
import { useCategory } from "../../hooks/ProductHooks";
import { Suspense } from "react";
import { Spinner } from "reactstrap";
import {
  productCategoryTitle,
  productCategoryUrl
} from "../../utils/ProductCategoryUtils";
import "./style.scss";

const CategoryCellInner = ({
  id,
  className,
  cellSize = "1x1",
  category: _category,
  theme = "black",
  requiresFeature,
  ...unhandledProps
}: GridCellCommonProps & { category: ProductCategory }) => {
  const tp = useProductTranslations();
  const category = useCategory(_category?._id);

  return category ? (
    <ImageCell
      id={id}
      className={classNames("category-cell", className)}
      cellSize={cellSize}
      theme={theme}
      requiresFeature={requiresFeature}
      heading={productCategoryTitle(category, tp)}
      text={category.tagline || ""}
      image={category.shop_herobox_background_image}
      url={productCategoryUrl(category) || shopUrl}
      {...unhandledProps}
    />
  ) : null;
};

const CategoryCell = ({
  id,
  className,
  cellSize = "1x1",
  category: _category,
  theme = "black",
  requiresFeature,
  ...unhandledProps
}: GridCellCommonProps & { category: ProductCategory }) => {
  const features = useSiteFeatures();

  return !requiresFeature || features.hasFeature(requiresFeature) ? (
    <Suspense
      fallback={
        <GridCell
          id={id}
          className={classNames("category-cell", className)}
          cellSize={cellSize}
          theme={theme}
        >
          <Spinner />
        </GridCell>
      }
    >
      <CategoryCellInner
        id={id}
        className={classNames("category-cell", className)}
        cellSize={cellSize}
        theme={theme}
        category={_category}
        requiresFeature={requiresFeature}
        {...unhandledProps}
      />
    </Suspense>
  ) : null;
};

export default CategoryCell;
